<div class="contents-main p-0">
    <!-- <div class="row form-styles mx-n2">
            <div class="col-12 d-sm-flex justify-content-between align-items-center">
                <div class="d-flex">
                    <div class="dataTables_length  p-0">
                        <label class="show-entries-list">
                            Show
                            <select [formControl]="pageSizeControl" (change)="changePageSize()"
                                class="form-control form-control-sm">
                                <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">{{limit.label}}
                                </option>
                            </select>
                            entries
                        </label>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="table-responsive position-relative sticky-head">
        <table class="table text-center">
            <thead>
                <tr>
                    <th scope="col">Alarm Id</th>
                    <th scope="col">Station Name</th>
                    <th scope="col">Alarm Severity</th>
                    <th scope="col">Alarm Name</th>
                    <th scope="col">Dev Name</th>
                    <th scope="col">Occurrence Time</th>
                    <th scope="col">Status</th>
                    <th scope="col">ESN Code</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="!isLoadingTable; else LoadingRow">
                    <ng-container *ngIf="row && row.length>0 else noRow">
                        <tr *ngFor="let row of row;let i=index">
                            <!-- <td>{{i+1}}</td> -->
                            <td>{{row.alarmId}}</td>
                            <td>{{row.stationName}}</td>
                            <td>{{row.alarmSeverity}}</td>
                            <td>{{row.alarmName}}</td>
                            <td>{{row.devName}}</td>
                            <td>{{row.occurrenceTime}}</td>
                            <td>{{row.status}}</td>
                            <td>{{row.esnCode}}</td>
                            <td>
                                <button class="btn btn-icon" title="View" (click)="onActivate(row,ticketDetail)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16"
                                        fill="none">
                                        <path
                                            d="M10.9257 11.2647C12.6406 11.2647 14.0307 9.87453 14.0307 8.15969C14.0307 6.44484 12.6406 5.05469 10.9257 5.05469C9.2109 5.05469 7.82074 6.44484 7.82074 8.15969C7.82074 9.87453 9.2109 11.2647 10.9257 11.2647Z"
                                            fill="currentColor" />
                                        <path
                                            d="M21.6058 7.36788C20.4381 5.54285 18.899 3.98433 17.0888 2.79388C15.2552 1.57348 13.1081 0.908826 10.9058 0.879883C8.90606 0.89852 6.95003 1.46692 5.25176 2.52288C3.26605 3.76116 1.56507 5.4059 0.260761 7.34888C0.0961226 7.58515 0.00545842 7.86504 0.000294584 8.15297C-0.00486925 8.4409 0.0757004 8.72386 0.231761 8.96588C1.381 10.7929 2.90616 12.3542 4.70576 13.5459C6.54235 14.7708 8.69821 15.4293 10.9058 15.4399C13.1121 15.4156 15.2647 14.756 17.1058 13.5399C18.9189 12.3485 20.456 10.7827 21.6138 8.94788C21.7652 8.71185 21.8457 8.43731 21.8457 8.15688C21.8457 7.87646 21.7652 7.60192 21.6138 7.36588L21.6058 7.36788ZM10.9208 12.5279C10.0569 12.5279 9.21234 12.2717 8.49403 11.7917C7.77572 11.3118 7.21586 10.6296 6.88526 9.83144C6.55465 9.0333 6.46815 8.15504 6.63669 7.30773C6.80523 6.46042 7.22124 5.68212 7.83212 5.07124C8.443 4.46036 9.2213 4.04435 10.0686 3.87581C10.9159 3.70727 11.7942 3.79377 12.5923 4.12438C13.3905 4.45498 14.0727 5.01484 14.5526 5.73315C15.0326 6.45147 15.2888 7.29597 15.2888 8.15988C15.2888 8.7335 15.1758 9.30149 14.9563 9.83144C14.7368 10.3614 14.415 10.8429 14.0094 11.2485C13.6038 11.6541 13.1223 11.9759 12.5923 12.1954C12.0624 12.4149 11.4944 12.5279 10.9208 12.5279Z"
                                            fill="currentColor" />
                                    </svg>
                                </button>
                                <button class="btn btn-dark btn-circle" title="Clear"
                                    (click)="openDelModal(row.id,modalDelete)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                        fill="none">
                                        <path d="M7.59808 6.8053L10.8885 10.0957L14.1789 6.8053" stroke="currentColor"
                                            stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.59809 13.7562L10.8879 10.4658L14.1783 13.7562" stroke="currentColor"
                                            stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
    <div class="table-meta sticky">
        <div class="entries">
            <span>Total Records: {{this.total_items }}</span>
        </div>
        <nav class="table-pagination">
            <ul>
                <li>
                    <div class="go-to-page d-flex align-items-center">
                        <label>Go to Page:</label>
                        <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo" min="1"
                            [max]="total_pages" (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" (click)="goToPage(pageToGo); pageToGo = null"
                                [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                        </div>
                    </div>
                </li>
                <li><a class="init-bg" id="firstPage" (click)="goToPage(1)" [class.disabled]="current_page === 1">1</a>
                </li>
                <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i class="fa fa-chevron-left"></i></a>
                </li>
                <li><a class="active">{{ current_page }}</a></li>
                <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                        [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a>
                </li>
                <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                        [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
            </ul>
        </nav>

    </div>
    <!-- <div class="card w-100">
            <ngx-datatable #myTable [style.width]="'100%'" class="material expandable table-responsive" [rows]="row"
                [headerHeight]="50" [footerHeight]="0" [columnMode]="'force'" [scrollbarH]="true" [rowHeight]="'auto'"
                [offset]="0" [externalSorting]="true" [messages]="{emptyMessage: 'No Alarm found.'}"
                (sort)="onSort($event)">
                <ngx-datatable-column [sortable]="false" name="Alarm ID" prop="id" [width]="80">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="row.id">
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>
                            {{row.alarmId}}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Station Name" prop="stationName">
                    <ng-template ngx-datatable-header-template let-column="column">
                        <a class="cursor-pointer" (click)="sortAlarms('stationName')">
                            Station Name
                            <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'stationName',
                                      'datatable-icon-up': sortColumn === 'stationName' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'stationName' && sortOrder === 'desc'}">
                            </span>
                        </a>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="form-group" style="margin-bottom: 0px">
                            <span>{{ row.stationName }}</span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Alarm Severity" prop="alarmSeverity">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                        let-value="row.alarmSeverity">
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>
                            {{ row.alarmSeverity }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Alarm Name" prop="alarmName">
                    <ng-template ngx-datatable-header-template let-column="column">
                        <a class="cursor-pointer" (click)="sortAlarms('alarmName')">
                            Alarm Name
                            <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'alarmName',
                                    'datatable-icon-up': sortColumn === 'alarmName' && sortOrder === 'asc',
                                    'datatable-icon-down': sortColumn === 'alarmName' && sortOrder === 'desc'}">
                            </span>
                        </a>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>{{ row.alarmName }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Dev Name" prop="devName">
                    <ng-template ngx-datatable-header-template let-column="column">
                        <a class="cursor-pointer" (click)="sortAlarms('devName')">
                            Dev Name
                            <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'devName',
                                      'datatable-icon-up': sortColumn === 'devName' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'devName' && sortOrder === 'desc'}">
                            </span>
                        </a>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>{{ row.devName }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Occurrence Time" prop="occurrenceTime">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row"
                        let-value="row.occurrenceTime">
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>
                            {{ row.occurrenceTime }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [sortable]="false" name="Status" prop="status">
                    <ng-template ngx-datatable-header-template let-column="column">
                        <a class="cursor-pointer" (click)="sortAlarms('status')">
                            Status
                            <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'status',
                                      'datatable-icon-up': sortColumn === 'status' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'status' && sortOrder === 'desc'}">
                            </span>
                        </a>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>{{ row.status }}</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [sortable]="false" name="Esn Code" prop="esnCode">
                    <ng-template ngx-datatable-header-template let-column="column">
                        <a class="cursor-pointer" (click)="sortAlarms('esnCode')">
                            Esn Code
                            <span class="sort-btn" [ngClass]="{'datatable-icon-sort-unset': sortColumn !== 'esnCode',
                                      'datatable-icon-up': sortColumn === 'esnCode' && sortOrder === 'asc',
                                      'datatable-icon-down': sortColumn === 'esnCode' && sortOrder === 'desc'}">
                            </span>
                        </a>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="form-group" style="margin-bottom: 0px"></div>
                        <span>{{ row.esnCode }}</span>
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column [sortable]="false">
                    <ng-template ngx-datatable-header-template let-column="column">
                            ACTION
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <button class="btn btn-icon" title="View" (click)="onActivate(row,ticketDetail)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16"
                                fill="none">
                                <path
                                    d="M10.9257 11.2647C12.6406 11.2647 14.0307 9.87453 14.0307 8.15969C14.0307 6.44484 12.6406 5.05469 10.9257 5.05469C9.2109 5.05469 7.82074 6.44484 7.82074 8.15969C7.82074 9.87453 9.2109 11.2647 10.9257 11.2647Z"
                                    fill="currentColor" />
                                <path
                                    d="M21.6058 7.36788C20.4381 5.54285 18.899 3.98433 17.0888 2.79388C15.2552 1.57348 13.1081 0.908826 10.9058 0.879883C8.90606 0.89852 6.95003 1.46692 5.25176 2.52288C3.26605 3.76116 1.56507 5.4059 0.260761 7.34888C0.0961226 7.58515 0.00545842 7.86504 0.000294584 8.15297C-0.00486925 8.4409 0.0757004 8.72386 0.231761 8.96588C1.381 10.7929 2.90616 12.3542 4.70576 13.5459C6.54235 14.7708 8.69821 15.4293 10.9058 15.4399C13.1121 15.4156 15.2647 14.756 17.1058 13.5399C18.9189 12.3485 20.456 10.7827 21.6138 8.94788C21.7652 8.71185 21.8457 8.43731 21.8457 8.15688C21.8457 7.87646 21.7652 7.60192 21.6138 7.36588L21.6058 7.36788ZM10.9208 12.5279C10.0569 12.5279 9.21234 12.2717 8.49403 11.7917C7.77572 11.3118 7.21586 10.6296 6.88526 9.83144C6.55465 9.0333 6.46815 8.15504 6.63669 7.30773C6.80523 6.46042 7.22124 5.68212 7.83212 5.07124C8.443 4.46036 9.2213 4.04435 10.0686 3.87581C10.9159 3.70727 11.7942 3.79377 12.5923 4.12438C13.3905 4.45498 14.0727 5.01484 14.5526 5.73315C15.0326 6.45147 15.2888 7.29597 15.2888 8.15988C15.2888 8.7335 15.1758 9.30149 14.9563 9.83144C14.7368 10.3614 14.415 10.8429 14.0094 11.2485C13.6038 11.6541 13.1223 11.9759 12.5923 12.1954C12.0624 12.4149 11.4944 12.5279 10.9208 12.5279Z"
                                    fill="currentColor" />
                            </svg>
                        </button>
                        <button class="btn btn-orange btn-circle" title="Clear"
                        [disabled]="row.clearButtonDisabled"
                            (click)="onClear()" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                fill="none">
                                <path d="M7.59808 6.8053L10.8885 10.0957L14.1789 6.8053" stroke="currentColor"
                                    stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.59809 13.7562L10.8879 10.4658L14.1783 13.7562" stroke="currentColor"
                                    stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div class="table-meta">
                <div class="entries">
                    <span>Total Records: {{this.total_items }}</span>
                </div>
                <nav class="table-pagination">
                    <ul>
                        <li>
                            <div class="go-to-page d-flex align-items-center">
                                <label>Go to Page:</label>
                                <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo" min="1"
                                    [max]="total_pages" (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button"
                                        (click)="goToPage(pageToGo); pageToGo = null"
                                        [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                </div>
                            </div>
                        </li>
                        <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                [class.disabled]="current_page === 1">1</a></li>
                        <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                    class="fa fa-chevron-left"></i></a></li>
                        <li><a class="active">{{ current_page }}</a></li>
                        <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a>
                        </li>
                        <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                    </ul>
                </nav>

            </div>

        </div> -->
    <!-- <div class="loaderwrapper" *ngIf="loader">
        <span class="loader"></span>
    </div> -->
</div>

<ng-template #ticketDetail let-c="close" let-d="dismiss" let-width="500">
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Alarm</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M7 7.69653L12.0515 12.748L17.103 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <table class="table text-center">
                <thead class="thead-dark text-uppercase">
                    <tr>
                        <th scope="col">Alarm ID</th>
                        <th scope="col">Alarm Type</th>
                        <th scope="col">Alarm Name</th>
                        <th scope="col">Cause Id</th>
                        <th scope="col">Station Name</th>
                        <th scope="col">Occurrence Time</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ this.alarmDetailsItem.alarmId }}</td>
                        <td>{{ this.alarmDetailsItem.alarmType }}</td>
                        <td>{{ this.alarmDetailsItem.alarmName }}</td>
                        <td>{{ alarmDetailsItem.causeId }}</td>
                        <td>{{ this.alarmDetailsItem.stationName }}</td>
                        <td>{{ alarmDetailsItem.occurrenceTime | date: 'MMM d, y, h:mm:ss a' }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table text-center">
                <thead class="thead-dark text-uppercase">
                    <tr>
                        <th scope="col">Alarm Severity</th>
                        <th scope="col">Dev Name</th>
                        <th scope="col">Esn Code</th>
                        <th scope="col">Status</th>
                        <th scope="col">DEV Type Id</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{{ this.alarmDetailsItem.alarmSeverity }}</td>
                        <td>{{ this.alarmDetailsItem.devName }}</td>
                        <td>{{ alarmDetailsItem.esnCode }}</td>
                        <td>{{ alarmDetailsItem.status }}</td>
                        <td>{{ alarmDetailsItem.devTypeId }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table">
                <thead class="thead-dark text-uppercase">
                    <tr>
                        <!-- <th scope="col">Alarm Cause</th> -->
                        <th scope="col" width="50%">Alarm Cause</th>
                        <th scope="col">Suggestion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <!-- <td>{{ alarmInfo.alarmCause }}</td> -->
                        <td style="white-space: pre-line; vertical-align: top;">{{ this.alarmDetailsItem.alarmCause }}
                        </td>
                        <td style="white-space: pre-line; vertical-align: top;">{{ alarmDetailsItem.suggestion }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="100%">
            <div class="fw-semibold text-center">
                No data found
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #modalDelete let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            Confirm Alarm Deletion
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" />
                <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <p class="text-center">Are you sure you want to clear this alarm?</p>
    </div>
    <div class="modal-footer no-bg justify-content-center">
        <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
            Cancel
        </button>
        <button type="button" class="btn btn-orange" (click)="c('confirm')">
            Delete
        </button>
    </div>
</ng-template>